import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { axiosConfig } from "../../../axios/axiosConfig";

const SubscriptionCommisionsTable = ({ refresh, onEdit }) => {
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchCommissions = async () => {
      setLoading(true);
      try {
       const response = await axiosConfig({
      method: "get",
      url: "/subscription/subscription-commisions/",
    });
        setCommissions(response?.data);
      } catch (error) {
        console.log("Error Fetching Commissions", error);
        toast.error("Error fetching Commissions");
      } finally {
        setLoading(false);
      }
    };
    fetchCommissions();
  }, [refresh]);

  return (
    <Box>
      <Box sx={{ background: "#04343a", p: "12px 20px" }}>
        <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>
          All Subscription Commissions
        </Typography>
      </Box>
      {loading ? (
        <Box display="flex" justifyContent="center" p={5}>
          <CircularProgress sx={{ color: "#016551" }} size={28} />
        </Box>
      ) : (
        <TableContainer component={Paper} elevation={0} sx={{ borderTop: "1px solid #eef2f7" }}>
          <Table>
            <TableHead>
              <TableRow>
                {["S.No", "Subscription Plan", "Commission Amount", "Status", "Actions"].map((label) => (
                  <TableCell
                    key={label}
                    sx={{
                      fontWeight: 700,
                      fontSize: "13px",
                      color: "#fff",
                      background: "#04343a",
                      borderBottom: "none",
                      padding: "12px 16px",
                    }}
                  >
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {commissions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                    No commissions found.
                  </TableCell>
                </TableRow>
              ) : (
                commissions.map((item, index) => (
                  <TableRow key={item.id} sx={{ "&:hover": { background: "#f0faf5" } }}>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{index + 1}</TableCell>
                    <TableCell>
                      <Typography sx={{ fontWeight: 600, color: "#016551", fontSize: "14px" }}>
                        {item.subscriptionplan_name}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>₹{item.commision_amount}</TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px", textTransform: "capitalize" }}>
                      {item.status}
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={() => onEdit(item)} sx={{ color: "#04343a" }}>
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default SubscriptionCommisionsTable;
